import {useInstance} from 'react-ioc';
import {DownOutlined} from '@ant-design/icons';
import type {MenuProps} from 'antd';
import {Button, Dropdown} from 'antd';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {Store} from '../../model/store/Store';
import {currencies, CurrencySymbol} from '../../shared/helpers/currencies';


interface Props {
    small?: boolean
    block?: boolean
}

export const SelectCurrency = observer(({small, block}:Props) => {

    const {rate} = useInstance(Store)
    const items: MenuProps['items'] = _.map(currencies, currency => ({
        key: currency.key,
        label: `${currency.key} (${currency.symbol})`,
        onClick: () => {rate.setCurrency(currency.key);},
    }));

    return (
        <Dropdown menu={{items}}>
            <Button block={block} size={small ? 'small' : 'large'}>{rate.currency} ({CurrencySymbol(rate.currency)})<DownOutlined/></Button>
        </Dropdown>
    )
})